<template>
  <div>
    <!-- 批量修改渠道包名 -->
    <el-dialog
      title="批量修改渠道名"
      :visible.sync="dialogNameVisible"
      width="90%"
      append-to-body
      top="1vh"
      >
      <el-form :inline="true" v-model="nameSearchValue" class="demo-form-inline">
        <el-form-item label="渠道ID:">
          <el-input
            v-model="nameSearchValue.id"
            placeholder="请输入渠道ID"
          ></el-input>
        </el-form-item>
        <el-form-item label="渠道名称:">
          <el-input
            v-model="nameSearchValue.name"
            placeholder="请输入渠道名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="渠道类型:">
          <el-select
            v-model="nameSearchValue.channel_type_id"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in channelTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="游戏:">
          <el-select
            v-model="nameSearchValue.game_id"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in gamesList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getNameChannelList"
            >搜索</el-button
          >
        </el-form-item>
        <br />
        <el-form-item label="批量修改渠道包名(名字最多20个中英文字符)[用换行分割]:">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            v-model="nameText"
            style="width:400px;">
          </el-input>
          <el-button style="margin-left: 10px;" type="success" @click="setNameChange"
            >填入</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        stripe
        v-loading="loadingData"
        ref="tableNameData"
        :data="namePackageList"
        :max-height="500"
        border
        style="width: 100%"
        @selection-change="handleNameSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="id" label="ID" width="150"> </el-table-column>
        <el-table-column prop="created_at" label="注册日期"> </el-table-column>
        <el-table-column prop="game.name" label="游戏名称"> </el-table-column>
        <el-table-column prop="name" label="渠道名称"> </el-table-column>
        <el-table-column prop="channel_name" label="渠道类型"> </el-table-column>
      </el-table>
      <div v-if="currentNameSelection.length">
        <p>批量修改：</p>
        <el-table
          :data="currentNameSelection"
          style="width: 100%">
        <el-table-column prop="id" label="ID" width="80"> </el-table-column>
        <el-table-column prop="name" label="渠道名称"> </el-table-column>
        <el-table-column label="新名称">
          <template slot-scope="scope">
            <el-input v-model="scope.row.new_name" placeholder="请输入修改的包名"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              @click="currentNameSelection = currentNameSelection.filter(({id}) => id !== scope.row.id)"
              type="danger" icon="el-icon-delete" circle></el-button>
          </template>
        </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="setNamePackageSelect">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 搜索/新增 -->
    <div class="channel-hd">
      <el-form
        :inline="true"
        v-model="searchValue"
        ref="addform"
        class="demo-form-inline"
      >
        <el-form-item label="渠道ID:">
          <el-input
            v-model="searchValue.id"
            placeholder="请输入渠道ID"
          ></el-input>
        </el-form-item>
        <el-form-item label="渠道名称:">
          <el-input v-model="searchValue.name"></el-input>
        </el-form-item>
        <el-form-item label="渠道类型:">
          <el-select
            v-model="searchValue.channel_type_id"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in channelTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="游戏:">
          <el-select
            v-model="searchValue.game_id"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in gamesList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchChannelList">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="exportChannel()">导出</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" @click="dialogNameVisible = true"
            >批量修改渠道名</el-button
          >
        </el-form-item>
      </el-form>
      <el-button type="success" plain @click="channelAddDialog"
        >渠道新增</el-button
      >
    </div>
    <el-table
      stripe
      ref="table"
      v-loading="loadingData"
      :data="tableData"
      :max-height="tableHeight"
      border
      style="width: 100%"
    >
      <el-table-column prop="id" label="ID" width="150"> </el-table-column>
      <el-table-column prop="created_at" label="注册日期"> </el-table-column>
      <el-table-column prop="game.name" label="游戏名称"> </el-table-column>
      <el-table-column prop="name" label="渠道名称"> </el-table-column>
      <el-table-column prop="channel_name" label="渠道类型"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="warning"
            plain
            @click="channelEditDialog(scope.row)"
            title="编辑"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalRecords"
      >
      </el-pagination>
    </div>

    <!-- 添加渠道对话框 -->
    <el-dialog
      title="渠道新增"
      :visible.sync="addDialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addform"
        :rules="rules"
        label-width="100px"
        ref="addform"
      >
        <el-form-item label="渠道名称" prop="name">
          <el-input type="textarea" placeholder="支持换行批量" v-model="addform.name"></el-input>
        </el-form-item>
        <el-form-item label="渠道类型" prop="channel_type_id">
          <el-select
            v-model="addform.channel_type_id"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in channelTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属游戏" prop="game_id">
          <el-select
            v-model="addform.game_id"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in gamesList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addchannelSubmit('addform')"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!-- 编辑渠道对话框 -->
    <el-dialog
      title="编辑渠道数据"
      :visible.sync="editDialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editform"
        :rules="rules"
        label-width="100px"
        ref="editform"
      >
        <el-form-item label="渠道名称" prop="name">
          <el-input v-model="editform.name"></el-input>
        </el-form-item>
        <el-form-item label="渠道类型" prop="channel_type_id">
          <el-select
            v-model="editform.channel_type_id"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in channelTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属游戏" prop="game_id">
          <el-select
            v-model="editform.game_id"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in gamesList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="editchannelSubmit('editform')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import fetch from "@/assets/js/axios.js";
import { throttle } from "@/assets/js/public.js";
import { urlSplicing } from "@/assets/js/public.js";
export default {
  name: "channel",
  components: {},
  data() {
    return {
      loadingData: false,
      searchValue: {
        channel_type_id: "",
        name: "",
        game_id: "",
      },
      tableHeight: 0,
      historyValue: {},
      tableData: [],
      gamesList: [],
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      channelTypeList: [],
      addDialogFormVisible: false,
      editDialogFormVisible: false,
      addform: {
        id: "",
        name: "",
        channel_type_id: "",
        game_id: "",
      },
      editform: {
        id: "",
        name: "",
        channel_type_id: "",
        game_id: "",
      },
      rules: {
        name: [{ required: true, message: "请输入渠道名称", trigger: "blur" }],
        channel_type_id: [
          { required: true, message: "请选择渠道类型", trigger: "change" },
        ],
      },
      // 批量修改渠道包名
      dialogNameVisible: false,
      namePackageList: [],
      loadingNameData: false,
      nameSearchValue: {
        id: "",
        channel_type_id: "",
        name: "",
        game_id: "",
      },
      nameText: "",
      multipleSelection: [],
      currentNameSelection: [],
    };
  },
  computed: {
    ...mapState(["host"]),
  },
  created() {
    this.getGameSelectList();
    this.getChannelType();
    this.getChannelList(true);
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["table"].doLayout();
    });
  },
  beforeMount(height) {
    var h = document.documentElement.clientHeight;
    this.tableHeight = h - 60; //减去页面上固定高度height
  },

  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.getChannelList(false);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getChannelList(false);
    },
    // 实现渠道数据的搜索
    searchChannelList() {
      this.currentPage = 1;
      this.getChannelList(true);
    },
    // 显示新增渠道对话框
    channelAddDialog: throttle(function() {
      this.addform = {
        id: "",
        name: "",
        channel_type_id: "",
        game_id: "",
      };
      this.addDialogFormVisible = true;
    }, 1000),

    // 导出
    exportChannel() {
      let params = {
        ...this.historyValue, // 传对应的搜索的值
        export: 1,
        token: sessionStorage.getItem("access_token"),
      };
      urlSplicing(this.host + "admin/channels/list", params);
    },

    // 实现渠道数据的新增
    addchannelSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const nameList = this.addform.name.split('\n')
          if (nameList && nameList?.length > 1) {
            this.$confirm(`是否批量生成${nameList.length}个渠道?`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.addChannel(nameList)
            })
          } else {
            this.addChannel()
          }
        }
      });
    },
    addChannel (nameList) {
      const data = {
        ...this.addform
      }
      if (nameList && nameList?.length) data['name'] = nameList.toString()
      fetch({
        url: "/admin/channels/create",
        method: "POST",
        data,
      }).then((res) => {
        if (res.data.status === 1) {
          this.$message({
            type: "success",
            message: "添加成功",
          });
          this.getChannelList();
          this.addDialogFormVisible = false;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 编辑渠道对话框--加载默认数据
    channelEditDialog(row) {
      this.editform.id = row.id;
      this.editform.name = row.name;
      this.editform.channel_type_id = row.channel_type_id;
      this.editform.game_id = row.game_id;
      this.editDialogFormVisible = true;
    },
    // 实现渠道的编辑操作
    editchannelSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          fetch({
            url: "/admin/channels/update",
            method: "POST",
            data: {
              ...this.editform,
            },
          }).then((res) => {
            if (res.data.status === 1) {
              this.$message({
                type: "success",
                message: "编辑成功",
              });
              this.getChannelList();
              this.editDialogFormVisible = false;
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
    },

    // 获取游戏选择列表数据
    getGameSelectList(row) {
      fetch({
        url: "/admin/games/select",
        method: "GET",
      }).then((res) => {
        this.gamesList = res.data.data;
      });
    },

    // 获取渠道类型数据
    getChannelType(row) {
      fetch({
        url: "/admin/channels/types",
        method: "GET",
      }).then((res) => {
        this.channelTypeList = res.data.data;
      });
    },

    // 展示渠道列表数据
    getChannelList(reload = false) {
      let searchValue = {};
      if (reload) {
        this.historyValue = JSON.parse(JSON.stringify(this.searchValue));
        searchValue = this.searchValue;
      } else {
        searchValue = this.historyValue;
      }
      this.loadingData = true;
      fetch({
        url: "/admin/channels/list",
        method: "GET",
        params: {
          //   channel_type_id: this.grantform.channel_type_id,
          //   channel_type_id: this.addform.channel_type_id,
          ...searchValue, // 传对应的搜索的值
          page: this.currentPage,
          per_page: this.pageSize,
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.tableData = res.data.data.data;
            this.totalRecords = res.data.data.total;
            let that = this;
            this.tableData.forEach((item, index) => {
              that.channelTypeList.forEach((type, i) => {
                if (item.channel_type_id == type.id) {
                  that.tableData[index]["channel_name"] = type.name;
                }
              });
            });
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
    getNameChannelList(reload = false) {
      this.loadingNameData = true;
      fetch({
        url: "/admin/channels/list",
        method: "GET",
        params: {
          ...this.nameSearchValue,
          page: 1,
          per_page: 1000,
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.namePackageList = res.data.data.data;
            this.multipleSelection = []
            // 多选表格，清空用户的选择
            this.$refs.tableNameData.clearSelection();
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
    setNameChange () {
      if (!this.nameText) {
        this.$message.error('请填写渠道名')
        return
      }
      if (!this.currentNameSelection?.length) {
        this.$message.error('请选择需要修改的渠道')
        return
      }
      const nameList = this.nameText.split('\n')
      this.currentNameSelection = this.currentNameSelection.map((item,index) => {
        const new_name = nameList[index]
        return {
          ...item,
          new_name
        }
      })
    },
    handleNameSelectionChange (val) {
      const clearList = this.multipleSelection.length ? this.currentNameSelection.filter(({id}) => !this.multipleSelection.find(item => item.id === id)) : this.currentNameSelection
      this.multipleSelection = val
      this.currentNameSelection = clearList.concat(val.length ? val.filter(({id}) => !clearList.find(item => item.id === id)) : val)
    },
    setNamePackageSelect() {
      // 参数names：格式{渠道id:"名字","渠道id":"名字"} 
      const names = {}
      let unnameList = []
      this.currentNameSelection.forEach(({id, name, new_name}) => {
        if (new_name) {
          names[id] = new_name
        } else {
          unnameList.push(`(ID: ${id})${name}`)
        }
      })
      if (unnameList?.length) {
        this.$alert(unnameList.join(';'), '以下选中渠道未修改', {
          confirmButtonText: '确定',
        })
        return
      }
      fetch({
        url: "/admin/channels/update_names",
        method: "POST",
        data: {
          names: JSON.stringify(names)
        }
      }).then((res) => {
        if (res.data.status) {
          this.nameText = ''
          this.unnameList = []
          this.currentNameSelection = []
          this.$refs.tableNameData.clearSelection()
          this.$message.success('批量修改成功')
          this.dialogNameVisible = false
        } else {
          this.$message.error('批量修改成功:' + res.data.message)
        }
      })
    },
  },
};
</script>
<style lang="less">
.pagination {
  text-align: right;
  margin-top: 20px;
  padding-bottom: 20px;
}
.channel-hd {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  .el-input-group {
    width: 370px;
  }
}
</style>
